import { getRoles, getSystemParameters, postNotification } from "../../api/";
import { createSliceWithThunks } from "../utils";

const initialState = {
  snackbar: {
    open: false,
    timeout: 3000,
    message: "",
    type: "info",
  },
  params: {
    data: null,
    status: null,
    error: null,
  },
  notification: {
    data: null,
    status: null,
    error: null,
  },
  roles: {
    data: null,
    status: null,
    error: null,
  },
};

export const commonSlice = createSliceWithThunks({
  name: "common",
  initialState: initialState,
  reducers: (create) => ({
    resetStateCommon: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    showSnackbar: create.reducer((state, { payload }) => {
      state.snackbar = { ...state.snackbar, ...payload };
    }),
    hideSnackbar: create.reducer((state) => {
      state.snackbar.open = false;
    }),
    fetchSystemParameter: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getSystemParameters(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.params.status = "loading";
        },
        rejected: (state, action) => {
          state.params.status = "failed";
          state.params.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.params.error = { message: respObj };
            } else if (status === "success") {
              state.params.data = respObj;
            }
          } else {
            state.params.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.params.status = "idle";
        },
      }
    ),
    fetchRoles: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getRoles(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.roles.status = "loading";
        },
        rejected: (state, action) => {
          state.roles.status = "failed";
          state.roles.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.roles.error = { message: respObj };
            } else if (status === "success") {
              state.roles.data = respObj;
            }
          } else {
            state.roles.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.roles.status = "idle";
        },
      }
    ),
    sendNotification: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postNotification(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.notification.status = "loading";
        },
        rejected: (state, action) => {
          state.notification.status = "failed";
          state.notification.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.notification.error = { message: respObj };
            } else if (status === "success") {
              state.notification.data = respObj;
            }
          } else {
            state.notification.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.notification.status = "idle";
        },
      }
    ),
  }),
});

export const {
  showSnackbar,
  hideSnackbar,
  resetStateCommon,
  sendNotification,
  fetchSystemParameter,
  fetchRoles,
} = commonSlice.actions;
export default commonSlice.reducer;
